export const OverlayType = {
  PRIVACY: 'privacy',
  POLICY: 'policy',
  TERMS: 'terms_and_conditions',
  COOKIES: 'cookies',
};
